module.exports = __webpack_public_path__ + "img/NightDosing.f19d2346.svg";